
import { makeStyles } from '@mui/styles';

const styles = (theme) => ({

    container: () => {
      return  {
          display: 'flex',
          height: '100vh',
          width: '100%',

          flexDirection: 'column !important',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'absolute',
          top: 0,
          left: 0,
          overflow: 'scroll',
      };
    },

    body: () => {
      return  {
        display: 'flex',
        width: 'calc(100% - 64px)',
        flexDirection: 'column !important',
        justifyContent: 'flex-start',
        alignItems: 'center',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          display: 'none', /* Hide the scrollbar completely */
          width: '0px',        /* For a very thin scrollbar */
          background: 'transparent', /* Make the track transparent */
        },
      };
    },

    content: ({ commonUIStyles }) => {
      function getHeight () {
        return 'calc(100%)';
      }
   
      return {
        display: 'flex',
        flexDirection: 'column !important',
        justifyContent: 'flex-start',
        alignItems: 'center',
        overflow: 'hidden',
        width: '100%',
        height: getHeight(),
  
        /* rest of css*/
        // overflowY: 'scroll',
        padding: '0px',
  
        /* for firefox*/
        scrollbarColor: 'transparent transparent',
        scrollbarWidth: '12px',
  
        '&::-webkit-scrollbar': {
            width: '12px',
            background: 'transparent',
        },
  
        '&::-webkit-scrollbar-thumb': {
            background: 'transparent',
            borderradius: '5px',
        },
  
        '&:hover': {
            'scrollbarColor': '#D9D9D9 transparent',
        },
  
      };
    },

    headerSpace: {
      width: '100%',
      marginBottom: '8px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },

    subtitle: () => {
      return  {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '20px',
      };
    },

    bodyMessages: () => {
      return  {
        display: 'flex',
        flexDirection: 'column !important',
        fontSize: '14px',
        width: '100%',
        fontWeight: 'regular',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '24px 0px',
        textAlign: 'center',
      };
    },
 
    buttonPanel: () => {
      return  {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
      };
    },
    
    progress: (p) => {
      const {
        commonUIStyles = {
          button: () => ({}),
        },
      } = p;

      return {
        color: `${commonUIStyles.foreColor()} !important`,
      };
    },
 
    didntsee: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: '24px',
      marginBottom: '24px',
     
      width: 'calc(100% - 64px)',
      justifyContent: 'center',
      [theme.breakpoints.down('xs')]: {
        fontSize: '14px',
        marginTop: '12px',
        marginBottom: '12px',
        flexDirection: 'column !important',
        alignItems: 'center',
      },
    },

    help: {
      marginTop: '24px',
      marginBottom: '52px',
      display: 'flex',
      flexDirection: 'row',
      width: 'calc(100% - 64px)',
      justifyContent: 'center',
      [theme.breakpoints.down('xs')]: {
        fontSize: '14px',
        marginTop: '12px',
      },
    },

    hr: {
      border: 0,
      height: '1px',
      width:  '50%',
      // background: '#aaaaaa',
      background: 'linear-gradient(left, #f0f0f0, #8c8b8b, #f0f0f0)',
    },

    guide: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
    },

    guideImage: {
      width: '100%',
      [theme.breakpoints.down('xs')]: {
        width: 'calc(100% - 48px)',
      },
      '&[data-platform="windowsIe"]': {
        width: '100%',
      },
    },

    spinnerBox: {
      display: 'flex',
      width: '70%',
    },
});

export default styles;
export const useStyles = makeStyles(styles);
